// extracted by mini-css-extract-plugin
export default {"box":"e465JzWCn4pCaOe0kT3U"};